export default "<img src=\"../../../assets/loading.svg\" alt=\"loading\">"